import React, { useState } from "react";
import { fileTypeCheck } from "../utils/objectUtils";
import { getApiUrl } from "../data/api/apiManager";

import "./profilePicturePicker.css";
import DragAndDrop from "./dragAndDrop";
import { openPopUp } from "./popUp";
import ProfilePicturePickerPopUp from "./profielPicturePickerPopUp";

import artistPlaceholder from "../assets/img/artist-placeholder.jpg";

interface profilePicturePickerProps {
    profilePictureContentHash: string;
    onChange: (file: File) => void;
}

export const allowedImgFileFormats = ["jpg", "jpeg", "png", "webp"];

export default function ProfilePicturePicker(props: profilePicturePickerProps) {

    const [file, setFile] = useState<string>("");

    function handleProfilePictureUpload(v: File[]) {
        if(!fileTypeCheck(v, allowedImgFileFormats)) return;
        var file = v[0];
        let reader = new FileReader();

        reader.onload = function () {
            const base64 = reader.result as string;
            setFile(base64);
        }
        reader.readAsDataURL(file);
        props.onChange(file);
    }

    return <div className="profile-picture-picker txoria-text-field">
        <DragAndDrop name="Drag and drop your profile picture" onUpload={handleProfilePictureUpload}/>
        <label>Profile Picture</label>
        <img onClick={() => {
            openPopUp(<ProfilePicturePickerPopUp profilePictureContentHash={props.profilePictureContentHash} file={file} onChange={handleProfilePictureUpload}/>);
        }} onError={() => {
            fetch("/artist-placeholder.webp")
            .then((response) => response.blob()) // Convert the image to a Blob
            .then((blob) => {
                const file = new File([blob], "artist-placeholder.webp", { type: blob.type });
                handleProfilePictureUpload([file]);
            })
            .catch((error) => console.error("Error loading image as file:", error));
        }} src={file ? file : getApiUrl("assets/by-hash/" + props.profilePictureContentHash)} className="profile-picture"/>
    </div>

}
